import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Field } from "@/components/Field";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const ResetPasswordDialog = ({ borrower, onOpenChange }) => {
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setPw(""); setErr(""); }, [borrower]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { setErr("Temporary password must be at least 8 characters"); return; }
    setBusy(true);
    try {
      const { data } = await api.post(`/borrowers/${borrower.id}/reset-password`, { password: pw });
      toast.success(data.message);
      onOpenChange(false);
    } catch (e2) {
      const { message, fields } = apiError(e2);
      setErr(fields.password || message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!borrower} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="reset-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Reset password</DialogTitle>
          <DialogDescription>{borrower?.name} will be asked to set a new password on next login.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} noValidate className="space-y-4">
          <Field label="Temporary password" name="password" error={err}>
            <Input id="password" value={pw} onChange={(e) => setPw(e.target.value)} className="h-10" data-testid="reset-password-input" autoComplete="new-password" />
          </Field>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button type="submit" disabled={busy} data-testid="reset-password-submit">{busy && <Loader2 className="animate-spin" />} Set temporary password</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
